import { useEffect } from "react"
import { useLocation, useParams } from "react-router-dom"
import { Toast } from '@nutui/nutui-react';


const Index = (props: any) => {
    const param = useParams()
    const l = useLocation()

    const urlParams = new URLSearchParams(l.search);

    const id = urlParams.get("id");
    const is_preview = urlParams.get("is_preview");
    const product_id = urlParams.get("product_id");
    useEffect(() => {
        Toast.loading(t('加载中'), {
            cover: true, // 是否展示透明遮罩层
            closeOnClickOverlay: false, // 点击遮罩可关闭
            duration: 0
        })
        if (param.token) {
            localStorage.setItem("token", param.token)
            Toast.hide()
            let targetPath = "";

            const isH5 = l.pathname.startsWith("/cloth/h5/entry");
            const isPC = l.pathname.startsWith("/cloth/pc/entry");
            const design_id = urlParams.get("design_id");
            if (isH5) {
                if (design_id) {
                    targetPath = `/cloth/h5/design/${id}?is_preview=${is_preview}&product_id=${product_id}&design_id=${design_id}`;
                } else {
                    targetPath = `/cloth/h5/design/${id}?is_preview=${is_preview}&product_id=${product_id}`;
                }
            } else if (isPC) {
                if (design_id) {
                    targetPath = `/cloth/pc/design/${id}?is_preview=${is_preview}&product_id=${product_id}&design_id=${design_id}`;
                } else {
                    targetPath = `/cloth/pc/design/${id}?is_preview=${is_preview}&product_id=${product_id}`;
                }
            }
            if (targetPath) {
                window.location.replace(targetPath);
            } else {
                Toast.fail("缺少必要的ID参数");
            }

        }
    }, [param.token, l.pathname, id])


    return (
        null
    )
}

export default Index